import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartBuyerIdentityUpdate = (
	`mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
		cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartBuyerIdentityUpdate;
